<template>
	<!-- 提示訊息框 -->
	<v-snackbar
		v-model="is_show"
		:multi-line="true"
		:timeout="timeout"
		:color="hint_color"
	>
		{{ message }}
		<template v-slot:action="{ attrs }">
			<v-btn
				text
				v-bind="attrs"
				@click="is_show = false"
			>
            關閉
			</v-btn>
		</template>
	</v-snackbar>	
</template>

<script>
export default {
  name: "vtoast",
  data() {
    return{
      is_show: false,
      message: '',
      hint_color: 'dark',
      timeout: 2000
    }
  },
  methods:{
    show(data) {
      this.message = data.message || 'missing "message".'
      this.hint_color = this.$vuetify.theme.themes['dark'][data.color] || 'dark'
      this.timeout = data.timeout || 2000
      this.is_show = true
    }
  }
}
</script>
